import React, { type ReactNode } from 'react';

function WidgetRow({ children }: { children: ReactNode }) {
  return <div className="mb-10 rounded bg-black-#28 p-10">{children}</div>;
}

export default WidgetRow;
